//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../goods/goods.less';
import goPay from '../buycar/goPay.vue';
import doRefund from './doRefund.vue';
import orderJS from './order.js';
import historyBackJS from "../common/historyBack";
export default {
    components: {
        goPay,
        doRefund
    },
    mixins: [orderJS, historyBackJS],
    data() {
        return {
            goodsOrder: {
                name: '加载中',
                address: '加载中',
                statusItem: {}
            },
            readyPayOrderId: '',
            popupShow: false
        };
    },
    methods: {
        goBack(replace = false) {
            if(replace) {
                if (this.activeIndex == 4) {
                    this.$router.replace('/refund');
                } else {
                    this.$router.replace('/order?index=' + (this.activeIndex ? this.activeIndex : 0));
                }
            } else {
                if (this.activeIndex == 4) {
                    this.$router.push('/refund');
                } else {
                    this.$router.push('/order?index=' + (this.activeIndex ? this.activeIndex : 0));
                }
            }
        },
        toGoodsDetail(item) {
            var backPath = "/orderDetail?readyPayOrderId="+this.readyPayOrderId+"&activeIndex="+this.activeIndex;
            backPath = encodeURIComponent(backPath);
            this.$router.push('/goodsDetail?backPath='+backPath+"&goodsId="+item.goodsId);
        },
        doRefresh(done) {
            this.loadDetail();
            setTimeout(() => {
                done && done(true);
            }, 1000);
        },
        showPayAction() {
            var payData = {
                goodsOrderId: this.goodsOrder.goodsOrderId,
                prices: this.goodsOrder.orderTotalPrices
            };
            this.$refs.goPayRef.showPayAction(payData);
        },
        //复制订单编号
        copyOrder() {
            let that = this;
            that.$copyText(that.goodsOrder.goodsOrderId).then(
                function(e) {
                    that.$vux.toast.text('复制成功');
                },
                function(e) {
                    that.$vux.toast.text('复制失败，请进行手动复制');
                }
            );
        },
        //撤销退款
        cancleRefund() {
            let that = this;
            that.$vux.confirm.show({
                content: `您将撤销本次申请，如果问题未解决，您还可以再次发起。确定继续吗？`,
                cancelText: '取消',
                confirmText: '确定',
                title: '提示',
                onConfirm() {
                    var data = {
                        goodsOrderId: that.goodsOrder.goodsOrderId,
                        status: that.goodsOrder.status
                    };
                    that.$axios.put('/api/v1.0/lonbonShop/cancelApply', that.qs.stringify(data)).then(function(response) {
                        if (response.status == 200) {
                            that.$vux.toast.text('已撤销退款');
                            that.loadDetail();
                        }
                    });
                }
            });
        },
        //取消订单
        cancleOrder() {
            let that = this;
            that.cancleOrderFunc(that.goodsOrder, function() {
                that.loadDetail();
            });
        },
        //删除订单
        deleteOrder() {
            let that = this;
            that.deleteOrderFunc(that.goodsOrder, function() {
                that.goBack();
            });
        },
        //确认收货
        sureTake() {
            let that = this;
            that.sureTakeFunc(that.goodsOrder, function() {
                that.loadDetail();
            });
        },
        //显示确认支付页面
        showIsPay() {
            this.popupShow = true;
        },
        //已完成支付
        surePay() {
            var that = this;
            this.popupShow = false;
            this.loadDetail(function() {
                if (that.goodsOrder.status == 0) {
                    that.$vux.alert.show({
                        title: '提示',
                        content: '系统检测到您尚未支付完成，请重新选择支付',
                        onHide() {
                            // that.showPayAction();
                        }
                    });
                }
            });
        },
        //重新选择支付
        rePay() {
            var that = this;
            this.popupShow = false;
            this.loadDetail(function() {
                if (that.goodsOrder.status == 0) {
                    that.showPayAction();
                } else {
                    that.$vux.alert.show({
                        title: '提示',
                        content: '系统检测到您已完成支付，无需重新支付',
                        onHide() {
                            // that.showPayAction();
                        }
                    });
                }
            });
        },
        loadDetail(callback) {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/orderDetails', {
                    params: {
                        goodsOrderId: that.readyPayOrderId
                    }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        var one = response.body;
                        one.createTimeStr = that.$moment(one.createTime * 1000).format('YYYY-MM-DD HH:mm:ss');
                        one.statusItem = that.$store.state.dict.statusStrList[one.status];
                        one.address = one.address.replace(/\s/g, '');
                        //是否显示按钮区域
                        if (one.status < 10) {
                            one.showBtnWrap = true;
                        } else {
                            one.showBtnWrap = false;
                        }
                        //图表展示判断
                        if (one.status == 0) {
                            one.statusImg = 'payWaiting.png';
                        } else if (one.status == 1) {
                            one.statusImg = 'shipWaiting.png';
                        } else if (one.status == 2) {
                            one.statusImg = 'receivWaiting.png';
                        } else if (one.status == 4 || one.status == 6) {
                            one.statusImg = 'afterSale.png';
                        } else {
                            one.statusImg = 'closeSale.png';
                        }
                        that.goodsOrder = one;
                        //待付款的时间计算
                        if (that.goodsOrder.status == 0) {
                            that.countDurationRemark();
                            clearInterval(window.countInterval);
                            window.countInterval = null;
                            window.countInterval = setInterval(() => {
                                that.countDurationRemark();
                            }, 1000);
                        } else {
                            clearInterval(window.countInterval);
                            window.countInterval = null;
                        }
                        callback && callback();
                    }
                });
        },
        countDurationRemark() {
            var endT = this.goodsOrder.createTime + 24 * 3600;
            var startT = new Date().getTime() / 1000;
            var duration = this.$countDuration(startT, endT, 'timestamp', 'second');
            if (duration == '0秒') {
                this.goodsOrder.status = 8;
                this.goodsOrder.statusItem = this.$store.state.dict.statusStrList[this.goodsOrder.status];
                clearInterval(window.countInterval);
                window.countInterval = null;
            } else {
                this.goodsOrder.statusItem.remark = '剩' + duration + '自动关闭';
            }
        },
        //延迟查询订单情况
        delayLoadDetail() {
            let that = this;
            setTimeout(() => {
                that.loadDetail(function() {
                    console.log('延迟查询订单状态：' + that.goodsOrder.status);
                    if (that.goodsOrder.status != 0) {
                        that.popupShow = false;
                    }
                });
            }, 3000);
        }
    },
    mounted() {
        var that = this;
        var readyPayOrderId = that.$route.query.readyPayOrderId;
        if (readyPayOrderId) {
            this.readyPayOrderId = readyPayOrderId;
            this.loadDetail(function() {
                //此参数代表由下单页进入该页面
                var openPay = that.$route.query.openPay;
                if (openPay) {
                    that.$nextTick(() => {
                        that.showPayAction();
                    });
                }
                //此参数代表由支付平台进入该页面
                var redirect = that.$route.query.redirect;
                console.log('redirect:' + redirect + ',status:' + that.goodsOrder.status);
                if (redirect) {
                    if (that.goodsOrder.status == 0) {
                        console.log('由支付平台进入该页面，但是未支付成功');
                        that.delayLoadDetail();
                        that.showIsPay();
                    } else {
                        console.log('由支付平台进入该页面，支付成功');
                    }
                }
            });
            //此参数用于返回跳转
            this.activeIndex = that.$route.query.activeIndex;
        } else {
            this.$router.push('/goods');
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/order/detail.vue